import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const { pathname, search } = useLocation();

    if (loading || user === null) {
        return <div className="py-24 text-center text-[#A3A3A3]">Authenticating…</div>;
    }
    if (!user || user === false) {
        const params = new URLSearchParams(search);
        params.set("next", pathname);
        return <Navigate to={`/login?${params.toString()}`} replace />;
    }
    return children;
}
